import React, { Component } from 'react'
import { appTypeConfig } from '../../../common/config'

export const withLensesListIntersection = (WrappedComponent) => {
  if (!appTypeConfig.areBothLensesAlwaysSame) {
    return WrappedComponent
  }

  return class extends Component {
    constructor(props) {
      super(props)
      this.state = {
        lensesL: props.lensesL,
        lensesR: props.lensesR,
      }
    }

    componentDidMount() {
      this.calculateIntersection()
    }

    componentDidUpdate(prevProps) {
      const prevFieldValues = prevProps?.fields?.$values() || prevProps?.fieldValues || {}
      const fieldValues = this.props?.fields?.$values() || this.props?.fieldValues || {}
      if (
        prevProps.lensesL !== this.props.lensesL ||
        prevProps.lensesR !== this.props.lensesR ||
        prevFieldValues?.leftLensEnabled !== fieldValues?.leftLensEnabled ||
        prevFieldValues?.rightLensEnabled !== fieldValues?.rightLensEnabled
      ) {
        this.calculateIntersection()
      }
    }

    calculateIntersection = () => {
      const { lensesL, lensesR, fieldValues, fields } = this.props
      const { leftLensEnabled, rightLensEnabled } =
        fieldValues || fields?.$values() || {}

      let newLensesL = lensesL
      let newLensesR = lensesR

      if (leftLensEnabled && rightLensEnabled) {
        const combinedLenses = lensesL.filter((lensL) => {
          const lensR = lensesR.find((lensR) => lensR._id === lensL._id)
          if (!lensR) return false

          const diametersR = lensR.diameters
          const diametersL = lensL.diameters
          const diametersStringifiedR = diametersR.map((d) => JSON.stringify(d))
          const diametersStringifiedL = diametersL.map((d) => JSON.stringify(d))

          const hasCommonDiameter = diametersL.some((diameterL, indexL) =>
            diametersR.some((diameterR, indexR) => {
              return (
                diametersStringifiedR[indexR] === diametersStringifiedL[indexL]
              )
            })
          )

          return hasCommonDiameter
        })

        newLensesR = combinedLenses
        newLensesL = combinedLenses
      }

      this.setState({ lensesL: newLensesL, lensesR: newLensesR })
    }

    render() {
      const { lensesL, lensesR } = this.state

      return (
        <WrappedComponent {...this.props} lensesR={lensesR} lensesL={lensesL} />
      )
    }
  }
}

export const withDiametersIntersection = (WrappedComponent) => {
  if (!appTypeConfig.areBothLensesAlwaysSame) {
    return WrappedComponent
  }

  return class extends Component {
    render() {
      const { currentLensL, currentLensR, fieldValues, fields } = this.props
      let lensR = currentLensR
      let lensL = currentLensL
      const { leftLensEnabled, rightLensEnabled } =
        fieldValues || fields?.$values() || {}

      // do the intersection only if both lenses are enabled and both lenses exist
      if (leftLensEnabled && rightLensEnabled && currentLensR && currentLensL) {
        const diametersR = currentLensR?.diameters
        const diametersL = currentLensL?.diameters
        const diametersStringifiedR = diametersR.map(JSON.stringify)
        const diametersStringifiedL = diametersL.map(JSON.stringify)

        const diameterIntersection = diametersR.filter((diameterR, indexR) =>
          diametersL.some(
            (diameterL, indexL) =>
              diametersStringifiedR[indexR] === diametersStringifiedL[indexL]
          )
        )

        lensR = { ...currentLensR, diameters: diameterIntersection }
        lensL = { ...currentLensL, diameters: diameterIntersection }
      }

      return (
        <WrappedComponent
          {...this.props}
          currentLensR={lensR}
          currentLensL={lensL}
        />
      )
    }
  }
}
